var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.areaNegocioId == 10 || _vm.areaNegocioId == 9)?_c('SolicitudesInterify'):_vm._e(),(_vm.areaNegocioId == 3)?_c('SolicitudesLlamadas'):_vm._e(),(_vm.areaNegocioId == 6 || _vm.areaNegocioId == 3)?_c('SolicitudesEmails'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }